"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "SVBFaqApiContextualSupport", {
  enumerable: true,
  get: function get() {
    return _SVBFaqApiContextualSupport.default;
  }
});
var _SVBFaqApiContextualSupport = _interopRequireDefault(require("./src/SVBFaqApiContextualSupport"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }